<template>
  <div
    class="swiper my-swiper"
    :class="displayLayout"
    ref="swiper"
    v-if="bannerList.length > 0"
  >
    <div class="swiper-wrapper">
      <div
        class="swiper-slide"
        v-for="(item, index) in bannerList"
        :key="index"
      >
        <img
          class="swiper-slide-image"
          data-swiper-parallax-scale="1"
          data-swiper-parallax-opacity="0.8"
          :src="item.picture"
          :alt="item?.game || 'banner'"
          @click="goDetail(item, index)"
          :fetchpriority="index === 0 ? 'high' : 'low'"
        />
      </div>
    </div>
    <!-- 分页 -->
    <div class="swiper-pagination my-pagination"></div>
  </div>
</template>

<script>
  // swiper参考文档: https://v8.swiperjs.com/swiper-api
  import Swiper from 'swiper/swiper-bundle.min'
  import 'swiper/swiper-bundle.min.css'
  import IndexMixin from './indexMixin'
  import { mapState, mapGetters } from 'vuex'
  import debounce from 'lodash/debounce'

  export default {
    name: 'Swiper2',
    mixins: [IndexMixin],
    props: {
      bannerList: { type: Array, default: () => [] },
    },
    data() {
      return {
        swiper: null,
        listener: null,
        isSlideCenterd: false,
      }
    },
    computed: {
      ...mapState(['isMobile']),
      ...mapGetters(['displayLayout']),
      datas() {
        return this.bannerList
      },
    },
    watch: {
      bannerList(val) {
        // 兼容到banner数据变化后,重新初始化swiper
        this.initSwiper(val || [], this.isSlideCenterd)
      },
    },
    mounted() {
      // 刚开始就要判断视口尺寸宽度
      this.isSlideCenterd = this.bannerList.length === 0
      this.onSizeChange()
      this.listener = window.addEventListener(
        'resize',
        debounce(this.onSizeChange, 600)
      )
    },
    beforeDestroy() {
      this.swiper && this.swiper.destroy()
      window.removeEventListener('resize', this.listener)
    },
    methods: {
      onSizeChange() {
        const w = window.innerWidth || document.documentElement.clientWidth
        if (w <= 768) {
          !this.isSlideCenterd && this.initSwiper(this.datas, true)
          this.isSlideCenterd = true
        } else {
          this.isSlideCenterd && this.initSwiper(this.datas, false)
          if (this.isSlideCenterd) {
            this.isSlideCenterd = false
          }
        }
      },
      initSwiper(datas, isSlideCenter = false) {
        this.$nextTick(() => {
          // 为了防止多个创建swiper导致swiper样式问题
          this.swiper && this.swiper.destroy()
          if (!this.$refs?.swiper) return
          // 创建swiper
          const swiper = new Swiper(this.$refs.swiper, {
            initialSlide: 0, // 默认展示第一个
            // loopedSlides: 2, //设置所要用到的loop 个数(一般设置大于可视slide个数2个即可)
            slidesPerView: 'auto', // 开启自定义slide宽度，配合css样式设置即可
            centeredSlides:
              this.isMobile || datas.length === 1 || isSlideCenter, // then active slide will be centered
            parallax: true,
            speed: 400,
            pagination: {
              // 分页
              el: '.swiper-pagination',
              type: 'bullets',
            },
            observer: true,
            observeParents: true,
            loop: datas.length > 1, // 循环模式: 如果大于一个,则开启循环模式.否则只展示一个
            autoplay: {
              delay: 4000,
              disableOnInteraction: false, // 交互后继续自动播放
            },
          })
          swiper.on('slideChange', () => {
            this.itemChange()
          })
          this.swiper = swiper
        })
      },
    },
  }
</script>

<style lang="scss" scoped>
  .my-swiper {
    width: 100%;
    height: 100%;
    margin-top: 15px;
    margin-bottom: 30px;

    .swiper-wrapper {
      display: flex;
      align-items: center;
    }

    .swiper-slide {
      &-active {
        height: 450px;
        opacity: inherit;
      }
      width: 960px;
      height: 380px;
      margin: 0 15px;
      border-width: 0;
      border-radius: 48px;
      background: rgba(255, 255, 255, 0.05);
      opacity: 0.6;

      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: inherit;
      }
    }

    .swiper-pagination.my-pagination {
      position: inherit;
      left: inherit;
      bottom: inherit;
      display: flex;
      justify-content: center;
      box-sizing: border-box;
      padding: 30px;

      ::v-deep .swiper-pagination-bullet {
        &.swiper-pagination-bullet-active {
          background: #ffffff;
        }
        display: block;
        width: 15px;
        height: 15px;
        background: #ccc;
      }
    }
  }
</style>
<style lang="scss" scoped>
  @import './index_pc.scss';
  @include styling();
  @media screen and (max-width: 960px) {
    $scale: scaled(960, 1080);
    @include styling($scale);
  }
  @media screen and (max-width: 800px) {
    $scale: scaled(800, 1080);
    @include styling($scale);
  }
  @media screen and (max-width: 768px) {
    $scale: scaled(768, 1080);
    @include styling($scale);
    .my-swiper.desktop-layout {
      min-width: 660px; // (600+30*2) ，与游戏列表的最小限宽 600 以及水平 padding: 30px 保持一致
      .swiper-wrapper {
        .swiper-slide {
          width: 450px;
          height: 210px;
          justify-content: center;
          & > img {
            position: static;
            width: 400px;
            height: 180px;
          }

          &-active {
            & > img {
              width: 450px;
              height: 210px;
            }
          }
        }
      }
    }
  }
</style>
